import React from 'react';
import { bool, func, string } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';

function Payment({ currentBalance, onDownloadPaymentDocument, onAccountPayment, accountUnpaidLoading }) {
  const balanceZero = currentBalance === '$0';
  const styleVar = !balanceZero ? stylesJS.debtAmount : {};
  return (
    <div style={appConfig.lineSections ? stylesJS.lineContainer : stylesJS.colorContainer}>
      <UTLabel large bold>
        {message('AccountStatus:accountStatus')}
      </UTLabel>
      <div style={stylesJS.payment}>
        <div style={stylesJS.amountLabel}>
          <UTLabel semibold>{message('AccountStatus:amountToPay')}</UTLabel>
        </div>
        <div style={stylesJS.balance}>
          <UTLabel big extrabold style={{ ...stylesJS.amount, ...styleVar }}>
            {currentBalance}
          </UTLabel>
        </div>
        <div style={stylesJS.buttonContainer}>
          {appConfig.payments.active ? (
            <UTButton
              disabled={balanceZero || accountUnpaidLoading}
              className={styles.payButton}
              onPress={onAccountPayment}
            >
              {message('AccountStatus:payNow')}
            </UTButton>
          ) : (
            appConfig.usePaymentDocuments && (
              <UTButton
                disabled={balanceZero}
                className={styles.payButton}
                onPress={onDownloadPaymentDocument}
              >
                {message('AccountStatus:paymentDocument')}
              </UTButton>
            )
          )}
        </div>
      </div>
    </div>
  );
}

Payment.propTypes = {
  currentBalance: string.isRequired,
  onDownloadPaymentDocument: func.isRequired,
  onAccountPayment: func.isRequired,
  accountUnpaidLoading: bool
};

export default Radium(Payment);
